module.exports = __webpack_public_path__ + "static/img/btn_search.a18f8c51.svg";